import ChatWindow from "./components/ChatWindow";

const ReviewSectionView = () => {

  return (
    <div className="mt-[5vh] w-full h-[95vh] p-5 md:p-7 md:pt-4 2xl:p-14 overflow-auto flex flex-col gap-4 xl:gap-8 ">
      <div className="w-full sm:w-[calc(100%-4rem)] lg:w-[55rem] xl:w-[60rem] mx-auto space-y-3">
        <ChatWindow />
      </div>
    </div>
  );
};

export default ReviewSectionView;

